import * as React from 'react';
var TriggerContext = /*#__PURE__*/React.createContext(null);
export default TriggerContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-picker/node_modules/rc-trigger/es/context.js
// module id = 1155
// module chunks = 0